// extracted by css-extract-rspack-plugin
export default {"wrapper":"nqbUb","search_opened":"rAqDh","searchOpened":"rAqDh","results_anchor":"gUMG0","resultsAnchor":"gUMG0"};